@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
  padding: spacing("16");
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
  @include elevation("1");
}

.header {
  display: flex;
  gap: spacing("16");
  align-items: center;
  flex-wrap: wrap;
}

.title {
  @include typography("Jp/20_W6");
  color: text("High");
  white-space: nowrap;
  flex-shrink: 0;
}

.buttonGroup {
  display: flex;
  gap: spacing("8");
  flex: 1;
  min-width: 0;
}

.contentWrapper {
  display: flex;
  gap: spacing("24");
  margin-top: spacing("16");
}

.radarChartContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: spacing("16");
  flex: 1;
  padding: spacing("32");

  svg {
    overflow: visible;
  }
}

.chartNote {
  @include typography("Jp/10_W3");
  color: text("Low");
  text-align: center;
  margin: 0;
}

.tableContainer {
  flex: 1;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border: none;
}

.tableHeader {
  @include typography("Jp/12_W3");
  color: text("High");
  text-align: left;
  padding: spacing("12") spacing("8");
  border: none;

  &:not(:first-child) {
    text-align: right;
  }
}

.tableCell {
  @include typography("Jp/12_W3");
  color: text("High");
  text-align: left;
  padding: spacing("8");
  border: none;
  vertical-align: top;

  &:not(:first-child) {
    text-align: right;
  }
}

.tableCellSub {
  @include typography("Jp/12_W3");
  color: text("Middle");
  margin-top: spacing("4");
}

.radarGrid {
  stroke: chart("Gray02");
}

.radarChart {
  fill: chart('Teal_Alpha20');
  stroke: chart('Teal05');
}

.radarDot {
  fill: chart('Teal05');
  r: 2;
  stroke: #fff;
}

.radarLabel {
  @include typography("Jp/10_W3");
  fill: text("Middle");
}
